import { render, staticRenderFns } from "./KpiRealization.vue?vue&type=template&id=9ed6834e&"
import script from "./KpiRealization.vue?vue&type=script&lang=js&"
export * from "./KpiRealization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports